/**
 * A scooter with a rider, seen from above, pointing up (north). The parent
 * rotates it to the heading - a side-view emoji turned to face the road looks
 * as if it has fallen over, a top-down marker turns the way a map marker should.
 */
const TopDownBike = ({ size = 40, color = '#1B4DE4', rider = '#F97316' }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" style={{ display: 'block' }}>
    {/* headlight cone - where the bike is going */}
    <path d="M20 2 L11 16 L29 16 Z" fill="rgba(27,77,228,0.28)" />
    {/* front wheel */}
    <rect x="17.5" y="6" width="5" height="9" rx="2.5" fill="#1F2937" />
    {/* deck */}
    <rect x="14" y="9" width="12" height="22" rx="6" fill={color} stroke="#fff" strokeWidth="1.5" />
    {/* handlebar */}
    <rect x="11" y="13" width="18" height="3" rx="1.5" fill="#1F2937" />
    {/* rear wheel */}
    <rect x="17.5" y="28" width="5" height="8" rx="2.5" fill="#1F2937" />
    {/* rider: shoulders then helmet */}
    <rect x="12" y="17" width="16" height="9" rx="4.5" fill={rider} />
    <circle cx="20" cy="20.5" r="5.5" fill="#fff" stroke="#1F2937" strokeWidth="2" />
  </svg>
);

export default TopDownBike;
